<template>
  <base-page-component>
    <div>
      <b-alert variant="danger"
               dismissible
               :show="showDismissibleAlert"
               @dismissed="showDismissibleAlert=false">
        {{ errMsg }}
      </b-alert>
      <div>
        <b-card>
          <div slot="header">
            mDesking Lockouts
          </div>
          <!-- User Interface controls -->
          <b-row>
            <b-col md="6" class="my-0">
              <b-form-group class="my-1">
                <b-input-group v-on:keyup.enter="LoadData" v-on:keyup.escape="ClearSearch">
                  <b-form-input @keydown.native="EscClearSearch" v-model="tbxFilter" id="tbxFilter"
                                placeholder="Type to search by Account Number"/>
                  <b-input-group-append>
                    <b-btn class="btn btn-default text-white ml-2" @click="ClearSearch">
                      <i class="fa fa-eraser" title="Clear Search"></i> <strong class="text-white">Clear</strong>
                    </b-btn>
                    <b-btn class="btn btn-warning text-white ml-2" @click="LoadData">
                      <i class="fa fa-search" title="Search"></i> <strong class="text-white">Search</strong>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6" class="my-1">
              <div class="mr-2" style="text-align:right">Showing {{ GetRowCount() }} / {{ totalCount }} records</div>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table id="tblMain" :items="FilteredRecords" hover striped bordered small :fields="fields"
                   :current-page="currentPage" :per-page="perPage" :sort-desc="true" show-empty>
            <template slot="LOCKOUT_TIME" slot-scope="row">
              {{ row.value | formatDateToNow }}
            </template>
            <template slot="CLEAR_LOCKOUT" slot-scope="row">
              <b-row class="px-2">
                <b-col md="12">
                  <b-button @click="ClearLockout(row.item.USER_ID)" class="btn btn-info text-white btn-sm">
                    <i class="fa fa-solid fa-shield"></i> <strong
                    class="text-white">Clear Lockout</strong>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-table>
          <!-- NAV -->
          <nav>
            <b-pagination :total-rows="GetRowCount(Items)" :per-page="perPage" v-model="currentPage" prev-text="Prev"
                          next-text="Next"/>
          </nav>
        </b-card>
      </div>
      <loading :show="boolLoading"
               :label="txtLoading">
      </loading>
    </div>
  </base-page-component>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import moment from 'moment'
import {basePageMixin} from '../mixins/basePageMixin'

export default {
  components: {
    loading
  },
  mixins: [basePageMixin],
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      txtLoading: 'Loading...',
      boolLoading: false,
      tbxFilter: undefined,
      intervalHandle: undefined,
      totalCount: 0,
      Items: [],
      itemsObject: {},
      fields: [
        {key: 'USER_ID', label: 'User ID', sortable: true},
        {key: 'ACCOUNT_NUMBER', label: 'Account number', sortable: true},
        {key: 'DEALERSHIP_NAME', label: 'Dealership Name', sortable: true},
        {key: 'USER_NAME', label: 'User Name', sortable: true},
        {key: 'LOCKOUT_TIME', label: 'Time Left on Lock Out', sortable: true},
        {key: 'CLEAR_LOCKOUT', label: '', sortable: false}
      ],
      currentPage: 1,
      perPage: 15
    }
  },
  created () {
    let self = this
    self.LoadData()
    self.IntervalLoadData()
  },
  methods: {
    async IntervalLoadData () {
      const self = this
      if (self.intervalHandle === undefined) {
        self.intervalHandle = setInterval(() => self.LoadData(), 30000)
        setTimeout(function () {
          if (self.intervalHandle !== undefined) {
            clearInterval(self.intervalHandle)
          }
        }, 180000)
      }
    },
    async LoadData () {
      let self = this
      self.toggleloader(true)

      let obj = {
        accountNumber: self.tbxFilter
      }

      let axiosConfig = {
        timeout: 60000
      }

      axios.post('/api/Internal/LoadmDeskingLockouts', obj, axiosConfig)
        .then(async response => {
          self.errMsg = ''
          self.showDismissibleAlert = false
          self.totalCount = response.data.length || 0
          self.Items = response.data || []
        })
        .catch(error => {
          if (error !== undefined && error.response !== undefined && error.response.status === 403) {
            self.$router.push('/login')
          }
          self.errMsg = 'There was an error getting data : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
          self.showDismissibleAlert = true
        }).then(response => {
          self.toggleloader(false)
        })
    },
    async ClearLockout (userID) {
      let self = this
      self.toggleloader(true)

      let obj = {
        userID: userID
      }

      let axiosConfig = {
        timeout: 60000
      }

      axios.post('/api/Internal/ClearmDeskingLockout', obj, axiosConfig)
        .then(async response => {
          self.errMsg = ''
          self.showDismissibleAlert = false
          await self.LoadData()
          self.showNotification('User lockout cleared')
        })
        .catch(error => {
          if (error !== undefined && error.response !== undefined && error.response.status === 403) {
            self.$router.push('/login')
          }
          self.errMsg = 'There was an error clearing lockout for user : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
          self.showDismissibleAlert = true
        }).then(response => {
          self.toggleloader(false)
        })
    },
    GetRowCount () {
      let self = this
      return self.FilteredRecords.length
    },
    ClearSearch () {
      let self = this
      self.tbxFilter = undefined
      self.LoadData()
    },
    EscClearSearch (event) {
      let self = this
      if (event.key === 'Escape') {
        self.ClearSearch()
      }
    }
  },
  filters: {
    formatDateToNow: function (date) {
      let m = moment(date)
      if (m.isValid()) {
        let localTime = m.add(moment().utcOffset(), 'm')
        return localTime.toNow(true)
      }
      return ''
    }
  },
  computed: {
    FilteredRecords: function () {
      let self = this

      if (self.boolLoading) {
        return []
      } else {
        return self.Items
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mDeskingLockouts.vue